export default __webpack_public_path__ + "static/media/people-with-dog.d9323f0f.png";